<sd-mobile-menu-step [componentName]="componentNames.CategoriesMenu">
  <div class="mobile-categories-menu">
    <cx-spinner *ngIf="loading$ | async; else items"></cx-spinner>
    <ng-template #items>
      <ng-container *ngIf="node$ | async as node">
        <sd-mobile-menu-item *ngIf="node.entry as entry" variant="link" class="text-semi" [url]="entry.url">
          Смотреть все
        </sd-mobile-menu-item>
        <ng-container *ngFor="let item of node.items">
          <sd-mobile-menu-item *ngIf="item.hasChildren; else link" (click)="goToCategory(item.name, item.nodeId)">
            {{ item.name }}
          </sd-mobile-menu-item>
          <ng-template #link>
            <sd-mobile-menu-item [url]="item.url" variant="link">
              {{ item.name }}
            </sd-mobile-menu-item>
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-template>
  </div>
</sd-mobile-menu-step>

<ng-container *ngIf="(deviceService.isMobileSmDown$ | async) === false">
  <sd-mobile-menu-step [componentName]="componentNames.MobileMainMenu">
    <sd-mobile-menu-item (click)="openCatalog()" [hideArrow]="true" class="btn-catalog">
      <cx-icon [type]="iconType.MOBILE_RUBRICATOR" class="mobile-rubricator-icon"></cx-icon>
      <span>Каталог</span>
    </sd-mobile-menu-item>
  </sd-mobile-menu-step>
</ng-container>
